function roundNumber(value: number, digits = 5): number {
  return +(value || 0).toFixed(digits);
}

export default roundNumber;
